import { App } from "antd";

/**
 * Used as central point to create notifications and messages.
 * @returns the objects to create notifications and messages with antd
 */
export function useFeedback() {
  const { notification, message, modal } = App.useApp();

  /**
   * Show a loading message, run a callback, and show a success message if the callback is successful or an error message if the callback fails.
   * @param callback
   * @param loadingMessage
   * @param successMessage
   * @param errorMessage
   * @returns the value returned by the callback, or undefined if the callback fails
   */
  async function handleLoadingFeedback<T>(
    callback: () => Promise<T>,
    loadingMessage: string,
    successMessage: string,
    errorMessage: string
  ): Promise<T | undefined> {
    let value = undefined;

    const hideLoadingMessage = message.loading(loadingMessage, 0);
    try {
      value = await callback();
      message.success(successMessage);
    } catch (e) {
      console.error(e);
      message.error(errorMessage);
    }
    hideLoadingMessage();

    return value;
  }

  return { notification, message, modal, handleLoadingFeedback };
}
